export default "__VITE_ASSET__06c067c8__"